import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

import { TableModule, TableLazyLoadEvent } from "primeng/table";
import { DialogModule } from 'primeng/dialog';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';

import { AdminPageHeaderComponent } from '../shared/admin-page-header/admin-page-header.component';
import { CampaignFormComponent } from './campaign-form/campaign-form.component'

import { CampaignService } from '../../services/campaign.service';
import { Campaign, Cluster } from '../../models/campaign';


@Component({
  selector: 'app-campaigns',
  imports: [
    AdminPageHeaderComponent,
    CampaignFormComponent,
    TableModule,
    CommonModule,
    DialogModule,
    ToastModule
  ],
  providers: [MessageService],
  templateUrl: './campaigns.component.html',
  styleUrl: './campaigns.component.scss'
})
export class CampaignsComponent {
  readonly title = 'Campanhas de Marketing';
  readonly subtitle = 'Crie e gerencie as campanhas para enviar notificações aos usuários.';

  errorMessage: string | null = null;

  isLoadingCampaigns = false;
  campaigns: Campaign[] = [];
  totalCampaigns = 0;
  page = 1;
  rowsPerPage = 10;

  displayCreateCampaignModal = false;

  constructor(
    private campaignService: CampaignService,
    private messageService: MessageService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.fetchCampaigns()
  }

  fetchCampaigns(): void {
    this.isLoadingCampaigns = true;

    this.campaignService.listCampaigns(undefined, this.page).subscribe({
      next: (response) => {
        this.campaigns = response.results;
        this.totalCampaigns = response.count;
        this.isLoadingCampaigns = false;
      },
      error: (error) => {
        this.errorMessage = 'Erro ao carregar campanhas.';
        console.error('Error fetching campaigns:', error);
        this.isLoadingCampaigns = false;
      }
    })
  }

  onLazyLoad(event: TableLazyLoadEvent) {
    const first = event.first ?? 0;
    this.page = Math.floor(first / this.rowsPerPage) + 1;
    this.fetchCampaigns();
  }

  openCreateCampaignDialog() {
    this.displayCreateCampaignModal = true;
  }

  createCampaignSucess() {
    this.displayCreateCampaignModal = false;
    this.messageService.add({
      severity: 'success',
      summary: 'Sucesso',
      detail: 'Campanha criada com sucesso!'
    });
    this.fetchCampaigns();
  }

  seeCampaignDetails(id: number) {
    this.router.navigate(['/dashboard/campaigns', id]);
  }
}
